import type { UserRole } from '../types/user';

const BOOTSTRAP_ADMIN_EMAILS = ['ceo@jasperkeyplay.com'];

/** Normalize Firestore / legacy role values to `admin` | `employee`. */
export function normalizeUserRole(raw: unknown): UserRole {
  if (raw === true) return 'admin';
  if (typeof raw === 'string') {
    const normalized = raw
      .trim()
      .toLowerCase()
      .replace(/^['"]|['"]$/g, '');
    if (normalized === 'admin' || normalized === 'administrator' || normalized === 'superadmin') {
      return 'admin';
    }

    return 'employee';
  }

  return 'employee';
}

export function isAdminRole(role: unknown): boolean {
  return normalizeUserRole(role) === 'admin';
}

function adminEmailAllowlist(): string[] {
  const fromEnv = (process.env.REACT_APP_CONSOLE_ADMIN_EMAILS || '')
    .split(',')
    .map((e) => e.trim().toLowerCase())
    .filter(Boolean);

  return [...new Set([...BOOTSTRAP_ADMIN_EMAILS.map((e) => e.toLowerCase()), ...fromEnv])];
}

/** Console operators allowed as admin when Firestore profile is missing or mismatched. */
export function isEnvAdminEmail(email: string | null | undefined): boolean {
  if (!email?.trim()) return false;
  const normalized = email.trim().toLowerCase();

  return adminEmailAllowlist().includes(normalized);
}
